<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8 text-slate-600 dark:text-slate-300">

  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">จัดการบัญชีธนาคาร</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">บัญชีรับโอนของลาน ใช้ในการเลือกบัญชีของใบแจ้งหนี้ รายได้ และการสมัครสมาชิก</p>
    </div>
    <div class="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
      <button type="button" (click)="onRefresh()" title="รีเฟรช"
        class="w-full sm:w-auto p-3 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center h-[46px]">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" type="button" (click)="openCreate()" [disabled]="!selectedSiteId"
        class="w-full sm:w-auto px-6 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-xl shadow-lg flex items-center justify-center gap-2 h-[46px] disabled:opacity-50">
        <span class="material-icons text-xl">add_circle</span>
        เพิ่มบัญชีธนาคาร
      </button>
    </div>
  </div>

  <div class="bg-white dark:bg-slate-800 rounded-3xl shadow border border-slate-100 dark:border-slate-700 overflow-hidden relative animate-fade-in-up">

    <!-- Control bar -->
    <div class="p-6 border-b border-slate-100 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">account_balance</span>
        รายการบัญชีธนาคาร
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </h3>

      <div class="flex flex-col md:flex-row gap-3 w-full xl:flex-1 xl:min-w-0 xl:justify-end">
        <!-- Status segmented selector -->
        <div class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-50 dark:border-slate-800 rounded-xl h-[46px] shadow-sm shrink-0">
          <button type="button" (click)="statusFilter.set('active')"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 flex items-center gap-1.5"
            [ngClass]="statusFilter() === 'active'
              ? 'bg-white dark:bg-slate-700 text-emerald-600 dark:text-emerald-400 shadow-sm'
              : 'text-slate-400 dark:text-slate-500 hover:text-amber-600'">
            ใช้งาน
            <span class="text-[11px] px-1.5 rounded-md bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600">{{ activeCount() }}</span>
          </button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button type="button" (click)="statusFilter.set('inactive')"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200 flex items-center gap-1.5"
            [ngClass]="statusFilter() === 'inactive'
              ? 'bg-white dark:bg-slate-700 text-rose-500 dark:text-rose-400 shadow-sm'
              : 'text-slate-400 dark:text-slate-500 hover:text-amber-600'">
            ปิดใช้งาน
            <span class="text-[11px] px-1.5 rounded-md bg-slate-100 dark:bg-slate-800 text-slate-500">{{ inactiveCount() }}</span>
          </button>
          <div class="w-[1px] h-4 bg-slate-200 dark:bg-slate-700 mx-1"></div>
          <button type="button" (click)="statusFilter.set('all')"
            class="px-3 h-full rounded-lg text-sm font-bold transition-all duration-200"
            [ngClass]="statusFilter() === 'all'
              ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm'
              : 'text-slate-400 dark:text-slate-500 hover:text-amber-600'">
            ทั้งหมด
          </button>
        </div>

        <!-- Search -->
        <div class="flex items-center bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-50 dark:border-slate-800 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 transition-all w-full md:flex-1 md:min-w-[320px] xl:max-w-md h-[46px]">
          <div class="relative flex-1 h-full">
            <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-xl">search</span>
            <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event)"
              placeholder="ค้นหาชื่อ / ธนาคาร / ชื่อบัญชี / เลขบัญชี"
              class="w-full pl-10 pr-4 h-full bg-transparent border-none text-sm font-medium text-slate-600 dark:text-slate-300 focus:ring-0 focus:outline-none placeholder:text-slate-400 dark:placeholder:text-slate-600">
          </div>
          <button *ngIf="searchText()" type="button" (click)="searchText.set('')" title="ล้างคำค้นหา"
            class="shrink-0 w-9 h-9 mr-1 rounded-lg text-slate-400 hover:text-amber-500 flex items-center justify-center">
            <span class="material-icons text-[18px]">close</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto min-h-[280px] custom-scrollbar">
      <table class="w-full text-left text-sm">
        <thead class="bg-slate-50 dark:bg-slate-800/50 text-xs uppercase text-slate-400">
          <tr>
            <th class="px-6 py-4">ID</th>
            <th class="px-6 py-4">ชื่อที่แสดง</th>
            <th class="px-6 py-4">ธนาคาร</th>
            <th class="px-6 py-4">ชื่อบัญชี</th>
            <th class="px-6 py-4">เลขที่บัญชี</th>
            <th class="px-6 py-4">ประเภท</th>
            <th class="px-6 py-4">สถานะ</th>
            <th class="px-6 py-4">อัปเดต</th>
            <th class="px-6 py-4 text-center">จัดการ</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of visibleAccounts()"
            class="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50/50 dark:hover:bg-slate-800/30">
            <td class="px-6 py-4 text-slate-400">{{ a.id }}</td>
            <td class="px-6 py-4 font-semibold text-slate-800 dark:text-slate-100" [class.opacity-60]="!a.active">{{ a.name || '-' }}</td>
            <td class="px-6 py-4" [class.opacity-60]="!a.active">{{ a.bankName || '-' }}</td>
            <td class="px-6 py-4" [class.opacity-60]="!a.active">{{ a.accountName || '-' }}</td>
            <td class="px-6 py-4 font-mono tracking-wide" [class.opacity-60]="!a.active">{{ a.accountNumber || '-' }}</td>
            <td class="px-6 py-4" [class.opacity-60]="!a.active">{{ a.accountType || '-' }}</td>
            <td class="px-6 py-4">
              <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-bold"
                [ngClass]="a.active
                  ? 'bg-emerald-50 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-rose-50 text-rose-500 dark:bg-rose-900/30 dark:text-rose-400'">
                <span class="w-1.5 h-1.5 rounded-full" [ngClass]="a.active ? 'bg-emerald-500' : 'bg-rose-500'"></span>
                {{ a.active ? 'ใช้งาน' : 'ปิดใช้งาน' }}
              </span>
            </td>
            <td class="px-6 py-4 text-xs text-slate-400">{{ formatDate(a.writeDate) }}</td>
            <td class="px-6 py-4">
              <div class="flex justify-center gap-1">
                <button type="button" (click)="openHistory(a)" title="ดูประวัติ"
                  class="p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 hover:text-amber-600">
                  <span class="material-icons text-[18px]">history</span>
                </button>
                <button *ngIf="canUpdate && a.active" type="button" (click)="openEdit(a)" title="แก้ไข"
                  class="p-2 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20 text-amber-600">
                  <span class="material-icons text-[18px]">edit</span>
                </button>
                <button *ngIf="canDelete && a.active" type="button" (click)="askToggleActive(a)" title="ปิดใช้งาน"
                  class="p-2 rounded-lg hover:bg-rose-50 dark:hover:bg-rose-900/20 text-rose-500">
                  <span class="material-icons text-[18px]">block</span>
                </button>
                <button *ngIf="canUpdate && !a.active" type="button" (click)="askToggleActive(a)" title="เปิดใช้งาน"
                  class="p-2 rounded-lg hover:bg-emerald-50 dark:hover:bg-emerald-900/20 text-emerald-600">
                  <span class="material-icons text-[18px]">restore</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && visibleAccounts().length === 0">
            <td colspan="9" class="px-6 py-16 text-center text-slate-400">
              <span class="material-icons text-4xl block mb-2 text-slate-300">account_balance</span>
              {{ accounts().length ? 'ไม่พบบัญชีตามเงื่อนไข' : 'ยังไม่มีบัญชีธนาคารของลานนี้' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-4 border-t border-slate-100 dark:border-slate-700 flex flex-wrap items-center justify-between gap-3">
      <div class="text-xs font-semibold text-slate-500">แสดง {{ visibleAccounts().length }} จาก {{ accounts().length }} รายการ</div>
      <div class="text-xs text-slate-400 flex items-center gap-1.5">
        <span class="material-icons text-[16px]">info</span>
        บัญชีที่ปิดใช้งานจะไม่แสดงในรายการเลือกบัญชี แต่เอกสารเดิมยังแสดงชื่อบัญชีได้ตามปกติ
      </div>
    </div>
  </div>
</div>

<!-- Create / Edit modal -->
<div *ngIf="isFormOpen" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-fade-in">
  <div class="relative w-full max-w-2xl bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm rounded-[2rem] shadow-2xl border border-slate-100/50 dark:border-slate-800/50 p-6 md:p-8 animate-fade-in-up max-h-[90vh] overflow-y-auto custom-scrollbar">

    <div *ngIf="isSaving()" class="absolute inset-0 bg-white/70 dark:bg-slate-900/70 backdrop-blur-xs z-50 flex items-center justify-center rounded-[2rem]">
      <div class="w-10 h-10 border-4 border-amber-400 border-t-transparent rounded-full animate-spin"></div>
    </div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-slate-100 dark:border-slate-800">
      <div>
        <h3 class="text-xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">account_balance</span>
          {{ form.id ? 'แก้ไขบัญชีธนาคาร' : 'เพิ่มบัญชีธนาคาร' }}
        </h3>
        <p class="text-xs text-slate-400 mt-1 ml-8">ลาน: {{ siteState.selectedSite()?.name || '-' }}</p>
      </div>
      <button type="button" (click)="closeForm()"
        class="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
        <span class="material-icons">close</span>
      </button>
    </div>

    <div class="space-y-5">
      <!-- Bank (custom searchable dropdown) -->
      <div class="relative">
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ธนาคาร <span class="text-rose-500">*</span></label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">account_balance</span>
          <input type="text" placeholder="เลือกหรือพิมพ์ชื่อธนาคาร" [(ngModel)]="form.bankName" maxlength="100"
            (focus)="isBankDropdownOpen = true" (input)="isBankDropdownOpen = true" (blur)="closeBankDropdown()"
            class="w-full pl-10 pr-10 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
          <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none transition-transform"
            [class.rotate-180]="isBankDropdownOpen">expand_more</span>
        </div>
        <div *ngIf="isBankDropdownOpen && filteredBankOptions.length" (mousedown)="$event.preventDefault()"
          class="absolute top-full mt-2 left-0 right-0 z-40 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 max-h-60 overflow-y-auto custom-scrollbar animate-fade-in">
          <button *ngFor="let b of filteredBankOptions" type="button" (click)="selectBank(b)"
            class="w-full text-left px-4 py-2.5 text-sm font-medium transition-colors flex items-center justify-between"
            [ngClass]="b === form.bankName
              ? 'bg-amber-50 dark:bg-amber-900/20 text-amber-600'
              : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-600'">
            {{ b }}
            <span *ngIf="b === form.bankName" class="material-icons text-[18px]">check</span>
          </button>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อที่แสดงในรายการเลือก <span class="text-rose-500">*</span></label>
        <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
          <span class="absolute left-3 material-icons text-slate-400 text-[20px]">label</span>
          <input type="text" placeholder="เช่น กสิกรไทย สาขาสยาม" [(ngModel)]="form.name" maxlength="150"
            class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ชื่อบัญชี <span class="text-rose-500">*</span></label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">person</span>
            <input type="text" placeholder="ชื่อเจ้าของบัญชี" [(ngModel)]="form.accountName" maxlength="150"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
          </div>
        </div>
        <div>
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">เลขที่บัญชี <span class="text-rose-500">*</span></label>
          <div class="relative flex items-center bg-slate-50 dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 focus-within:ring-2 focus-within:ring-amber-200 dark:focus-within:ring-amber-500/30 h-[46px]">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">pin</span>
            <input type="text" placeholder="xxx-x-xxxxx-x" [(ngModel)]="form.accountNumber" maxlength="30"
              class="w-full pl-10 pr-4 py-2 bg-transparent border-none text-sm font-medium font-mono tracking-wide text-slate-700 dark:text-slate-200 focus:outline-none placeholder:text-slate-400">
          </div>
        </div>
      </div>

      <div>
        <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทบัญชี</label>
        <div class="flex flex-wrap gap-2">
          <button *ngFor="let t of accountTypeOptions" type="button" (click)="selectAccountType(t)"
            class="px-4 h-[42px] rounded-xl border text-sm font-bold transition-all flex items-center gap-1.5"
            [ngClass]="form.accountType === t
              ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-300 dark:border-amber-700 text-amber-600 dark:text-amber-400'
              : 'bg-slate-50 dark:bg-slate-800 border-slate-100 dark:border-slate-700 text-slate-500 dark:text-slate-400 hover:border-amber-300 hover:text-amber-600'">
            <span class="material-icons text-[18px]">{{ form.accountType === t ? 'radio_button_checked' : 'radio_button_unchecked' }}</span>
            {{ t }}
          </button>
          <span *ngIf="form.accountType && !accountTypeOptions.includes(form.accountType)"
            class="px-4 h-[42px] rounded-xl border bg-amber-50 border-amber-300 text-amber-600 text-sm font-bold flex items-center">
            {{ form.accountType }}
          </span>
        </div>
      </div>
    </div>

    <div class="flex justify-between gap-3 mt-8 pt-6 border-t border-slate-100 dark:border-slate-800">
      <button *ngIf="form.id" type="button" (click)="openFormHistory()" [disabled]="isSaving()"
        class="px-5 py-2.5 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-500 font-bold hover:border-amber-400 hover:text-amber-600 transition-all cursor-pointer inline-flex items-center justify-center gap-2 disabled:opacity-50">
        <span class="material-icons text-[18px]">history</span>
        ดูประวัติ
      </button>
      <div class="flex justify-end gap-3 ml-auto">
        <button type="button" (click)="closeForm()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-slate-800 transition-all disabled:opacity-50">
          ยกเลิก
        </button>
        <button type="button" (click)="saveForm()" [disabled]="isSaving()"
          class="px-6 py-2.5 rounded-xl font-bold bg-amber-400 hover:bg-amber-500 text-white shadow-lg shadow-amber-200/50 dark:shadow-amber-900/20 transition-all disabled:opacity-60 flex items-center gap-2">
          <span *ngIf="isSaving()" class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
          {{ isSaving() ? 'กำลังบันทึก...' : 'บันทึก' }}
        </button>
      </div>
    </div>
  </div>
</div>

<app-pss-confirm-modal *ngIf="toggleTarget"
  [title]="toggleTarget.active ? 'ปิดใช้งานบัญชีนี้?' : 'เปิดใช้งานบัญชีนี้?'"
  message="บัญชี "
  [highlight]="toggleTarget.name + ' (' + toggleTarget.accountNumber + ')'"
  [messageSuffix]="toggleTarget.active ? ' จะไม่แสดงในรายการเลือกบัญชีอีก (เอกสารเดิมไม่ได้รับผลกระทบ)' : ' จะกลับมาแสดงในรายการเลือกบัญชี'"
  [confirmLabel]="toggleTarget.active ? 'ปิดใช้งาน' : 'เปิดใช้งาน'"
  [variant]="toggleTarget.active ? 'danger' : 'warning'"
  [icon]="toggleTarget.active ? 'block' : 'restore'"
  [showIrreversibleNote]="false"
  [loading]="isSaving()"
  (confirm)="confirmToggleActive()"
  (cancel)="toggleTarget = null">
</app-pss-confirm-modal>

<app-modal-admin-activity-history *ngIf="historyTarget"
  [entityType]="activityEntityTypes.BankAccount"
  [entityId]="historyTarget.id"
  title="ประวัติบัญชีธนาคาร"
  [subtitle]="historyTarget.name + ' · ' + historyTarget.accountNumber"
  (close)="historyTarget = null">
</app-modal-admin-activity-history>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
